export default {
  tipoDoc: 'Documento de identificación',
  nroDoc: 'Número de documento',
  nombres: 'Nombres',
  primerAp: 'Primer apellido',
  segundoAp: 'Segundo apellido',
  telefono: 'Número de teléfono móvil',
  email: 'Correo electŕonico',
  nacionalidad: 'Nacionalidad',
  nro_apostilla: 'Número de apostilla',
  cod_seguridad: 'Código de seguridad',
  codigo: 'Código de seguimiento',
  day: 'Día',
  month: 'Mes',
  year: 'Año',
  nombre_solicitante: 'Nombre del titular del documento',
  precio: 'Precio',
  estado: 'ESTADO',
  fecha_expedicion: 'Fecha de expedición de la apostilla',
  fecha_nacimiento: 'Fecha de nacimiento',
  fecha_solicitud: 'Fecha de solicitud (es)',
  docFactura: 'Número de documento',
  tipoFactura: 'Tipo de documento',
  nombreFactura: 'Nombre completo',
  det_tramite: 'Detalles de su trámite',
  info_sol: 'TITULAR DEL DOCUMENTO',
  info_doc: 'DOCUMENTO(S)',
  info_pago: 'DATOS DE PAGO',
  info_finalizado: 'FINALIZADO',
  info_cont: 'Ingrese sus datos personales y de contacto para recibir notificaciones sobre el estado de su trámite',
  info_agregar: 'Agregue el/los documento(s) que necesita apostillar',
  alert_doc: 'Todavía no tiene ningún documento agregado',
  mis_doc: 'Mis documentos',
  desc_doc: 'Descripción del/de los documento(s)',
  select_doc: 'Seleccione un documento para apostillar',
  doc: 'Documento',
  docs: 'Documentos',
  titulo_factura: 'Ingrese sus datos para la factura',
  datos_pago: 'Verifique los datos de pago. La factura solo cubre el pago de la(s) apostilla(s)',
  titular_factura: 'Señor(es)',
  costo_doc: 'Costo de documento(s)',
  costo_apostilla: 'Costo apostilla(s)',
  confirmacion_solicitud: '¿Está seguro que quiere realizar su solicitud con estos datos? <br /> Revise bien los datos antes de continuar.',
  confirmar: 'Confirmar',
  aceptar: 'Aceptar',
  cancelar: 'Cancelar',
  fin_solicitud: '¡Su solicitud se ha realizado correctamente!',
  cod_seguimiento: 'Su código de seguimiento es:',
  guardar_codigo: 'Guarde el código',
  seguimiento_codigo: ' de seguimiento para ver el estado de su solicitud ingresando ',
  aqui: 'aquí',
  ingrese_codigo_seguimiento: 'Ingrese el código de seguimiento para ver el estado de su trámite.',
  verificar_documento: 'Ingresa la información requerida para poder verificar que el documento se encuentre apostillado.',
  datos_del_solicitante: 'Datos del solicitante',
  pago_entidad: 'Pagado en la entidad',
  pago_cancilleria: 'Pagado en Cancillería',
  regional: 'Regional',
  factura_tipo_documento: 'Tipo de documento',
  factura_titular_factura: 'Titular de factura',
  factura_nro_documento: 'Nro. de documento'
};



// WEBPACK FOOTER //
// ./src/lang/es/fields.js